import 'angular';

import { InvoiceVehicleSelectionCtrl }     from './vehicle.vehicle-selection-invoice';
import { VehicleAdvertisingCtrl }          from './vehicle.advertising';
import { VehicleAdvertisingDirective }     from './vehicle.advertising.directive';
import { VehicleAttachmentsDirective }     from './vehicle.attachments.directive';
import { VehicleCtrl }                     from './vehicle';
import { VehicleEventsCtrl }               from './vehicle.vehicle-events';
import { VehicleEventsDirective }          from './vehicle.vehicle-events.directive';
import { VehicleImportedHistoryCtrl}       from './vehicle.imported-history';
import { VehicleImportedHistoryDirective } from './vehicle.imported-history.directive.ajs';
import { VehicleInspectionsCtrl }          from './vehicle.vehicle-inspections';
import { VehicleInspectionsDirective }     from './vehicle.vehicle-inspections.directive';
import { VehicleInvoicesCtrl }             from './vehicle.vehicle-invoices';
import { VehicleInvoicesDirective}         from './vehicle.vehicle-invoices.directive';
import { VehiclesCtrl }                    from './vehicles';
import { VehicleSelectionCtrl }            from './vehicle.selection';
import { VehicleSelectionDirective }       from './vehicle.selection.directive';
import { VehiclesStates }                  from './vehicles.states.ajs';
import { VehicleTransactionComponent }     from './vehicle.transaction.component.ajs';
import { VehicleTransactionCtrl }          from './vehicle.transaction.ajs';
import { VehicleTransactionsCtrl }         from './vehicle.vehicle-transactions';
import { VehicleTransactionsDirective }    from './vehicle.vehicle-transactions.directive';
import { VehicleViewHistoryNotesCtrl }     from './vehicle.view-history-notes';


angular.module('workshop.vehicles', [])
  .component('worVehicleTransaction', VehicleTransactionComponent)
  .config(VehiclesStates)
  .controller('InvoiceVehicleSelectionCtrl', InvoiceVehicleSelectionCtrl)
  .controller('VehicleAdvertisingCtrl', VehicleAdvertisingCtrl)
  .controller('VehicleCtrl', VehicleCtrl)
  .controller('VehicleEventsCtrl', VehicleEventsCtrl)
  .controller('VehicleImportedHistoryCtrl', VehicleImportedHistoryCtrl)
  .controller('VehicleInspectionsCtrl', VehicleInspectionsCtrl)
  .controller('VehicleInvoicesCtrl', VehicleInvoicesCtrl)
  .controller('VehiclesCtrl', VehiclesCtrl)
  .controller('VehicleSelectionCtrl', VehicleSelectionCtrl)
  .controller('VehicleTransactionCtrl', VehicleTransactionCtrl)
  .controller('VehicleTransactionsCtrl', VehicleTransactionsCtrl)
  .controller('VehicleViewHistoryNotesCtrl', VehicleViewHistoryNotesCtrl)
  .directive('vehicleAdvertising', VehicleAdvertisingDirective)
  .directive('vehicleAttachments', VehicleAttachmentsDirective)
  .directive('vehicleEvents', VehicleEventsDirective)
  .directive('vehicleImportedHistory', VehicleImportedHistoryDirective)
  .directive('vehicleInspections', VehicleInspectionsDirective)
  .directive('vehicleInvoices', VehicleInvoicesDirective)
  .directive('vehicleSelection', VehicleSelectionDirective)
  .directive('vehicleTransactions', VehicleTransactionsDirective);